import styled from 'styled-components';

export const Page = styled.div`
  width: 98%;
  margin: auto;
  padding: 5px;
  padding-bottom: 100px;
  margin-bottom: 100px;
  text-align: center;
  .ant-col {
    padding: 0px 4px;
  }
`;

export const ContainGrid = styled.div`
  padding-bottom: 150px;
`;
